import { BaseElement, defineElement } from '@webtides/element-js';

class DecorationElement extends BaseElement {
    connected() {
        const resizeObserver = new ResizeObserver(() => {
            this.onResize();
        });

        resizeObserver.observe(this);
    }

    properties() {
        return {
            lastLine: false,
        };
    }

    onResize() {
        const rects = Array.from(this.firstElementChild.getClientRects());
        let width = 0;

        if (this.lastLine) {
            const last = rects.pop();
            width = last.width;
        } else {
            rects.forEach((rect) => {
                if (rect.width >= width) {
                    width = rect.width;
                }
            });
        }

        this.style.setProperty('--decoration-width', `${width}px`);
    }
}

export function define() {
    defineElement('decoration-element', DecorationElement);
}
